module.exports = require('./helpers/bundle-url').getBundleURL('dKyGs') + "map-icon.20f93e01.png";